import React from 'react';
import { mergeRectangles } from '../../utils/geometry';
import HighlightDiv from './HighlightDiv';

export default function HighlightLayer({ highlights, pageNumber, zoom }) {
  const pageHighlights = highlights.filter((h) => h.pageNumber === pageNumber);

  if (!pageHighlights.length) return null;

  const mergedHighlights = mergeRectangles(pageHighlights);

  return (
    <div
      className="highlight-layer"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 15,
      }}
    >
      {mergedHighlights.map((rect, i) => (
        <HighlightDiv key={`${pageNumber}-${i}`} rect={rect} zoom={zoom} />
      ))}
    </div>
  );
}